import { 
    SET_LOADING,
    SET_PAST_AUDITION_LIST,
    SET_PAST_AUDITION_LIST_META,
    SET_DRAFT_AUDITION_LIST,
    SET_DRAFT_AUDITION_LIST_META,
    SET_ACTIVE_AUDITION_LIST,
    SET_ACTIVE_AUDITION_LIST_META,
    APPEND_ACTIVE_AUDITION_LIST,
    APPEND_DRAFT_AUDITION_LIST,
    APPEND_PAST_AUDITION_LIST
} from "../../actions/auditions/types";

const INITIAL_STATE = {
    loading: false,
    activeAuditionsList: [],
    activeAuditionsListMetaData: {
        loading: false, hasMore: true
    },
    pastAuditionsList: [],
    pastAuditionsListMetaData: {
        loading: false, hasMore: true
    },
    draftAuditionsList: [],
    draftAuditionsListMetaData: {
        loading: false, hasMore: true
    },
}

const AuditionReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_ACTIVE_AUDITION_LIST: {
            return {
                ...state,
                activeAuditionsList: action.payload
            }
        }
        case SET_ACTIVE_AUDITION_LIST_META: {
            return {
                ...state,
                activeAuditionsListMetaData: action.payload
            }
        }
        case APPEND_ACTIVE_AUDITION_LIST: {
            return {
                ...state,
                activeAuditionsList: [ ...state.activeAuditionsList, ...action.payload]
            }
        }
        case SET_PAST_AUDITION_LIST: {
            return {
                ...state,
                pastAuditionsList: action.payload
            }
        }
        case SET_PAST_AUDITION_LIST_META: {
            return {
                ...state,
                pastAuditionsListMetaData: action.payload
            }
        }
        case APPEND_PAST_AUDITION_LIST: {
            return {
                ...state,
                pastAuditionsList: [ ...state.pastAuditionsList, ...action.payload]
            }
        }
        case SET_DRAFT_AUDITION_LIST: {
            return {
                ...state,
                draftAuditionsList: action.payload
            }
        }
        case SET_DRAFT_AUDITION_LIST_META: {
            return {
                ...state,
                draftAuditionsListMetaData: action.payload
            }
        }
        case APPEND_DRAFT_AUDITION_LIST: {
            return {
                ...state,
                draftAuditionsList: [ ...state.draftAuditionsList, ...action.payload]
            }
        }
        case SET_LOADING: {
            return {
                ...state,
                loading: action.payload
            }
        }
        default: {
            return state;
        }
    }
}

export default AuditionReducer;